import React from "react"

import { CalculatorResultType } from "@common-shared/config/coverage.config"
import { IOneVerifyCoverageResult } from "@common-shared/types/responseData/oneVerifyResponseData.types"

import { TOOLTIPS_CONFIG } from "../../config/tooltips.config"
import { HtmlHelper } from "../../helpers/html.helper"

export const PartialCoverageBadgeElement: React.FunctionComponent<{
    coverageResult: IOneVerifyCoverageResult
}> = props => {
    if (
        props.coverageResult.resultType !==
        CalculatorResultType.activePartialCoverage
    ) {
        return null
    }

    return HtmlHelper.getHtmlWrappedBadge(
        "Cost Estimates Not Supported",
        undefined,
        TOOLTIPS_CONFIG.coverageBreakdown.activePartialCoverage,
    )
}
